module.exports = __webpack_public_path__ + "img/antes_despues_72.9b5f230c.png";